import React from "react";
import { Star, ArrowRight, Sparkles, BookOpen } from "lucide-react";
import { ASSETS, APP_URL } from "@/data/landing";
import { Reveal, Btn } from "@/components/landing/primitives";

export const HeroSection = () => (
  <section id="top" data-testid="hero-section" className="relative pt-[10.5rem] pb-20 lg:pt-52 lg:pb-28">
    <div className="absolute top-0 right-0 w-[45%] h-[75%] bg-gradient-to-br from-afwn-green/15 via-afwn-amber/10 to-afwn-magenta/15 rounded-bl-[6rem] -z-0" />
    <div className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-afwn-amber/20 blur-3xl -z-0" />
    <div className="absolute top-1/3 -right-10 w-80 h-80 rounded-full bg-afwn-magenta/15 blur-3xl -z-0" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <span className="inline-flex items-center gap-2 px-3 py-1 text-xs tracking-wider uppercase rounded-full font-semibold bg-afwn-green/10 text-afwn-green">
            <Sparkles size={14} /> Anxiety Fix Wellness Network
          </span>
        </Reveal>
        <Reveal i={1}>
          <h1 className="mt-6 font-heading font-light tracking-tight leading-[1.05] text-5xl sm:text-6xl lg:text-7xl text-afwn-navy">
            Stay calm, clear<br />& <span className="italic text-afwn-green">in control.</span>
          </h1>
        </Reveal>
        <Reveal i={2}>
          <p className="mt-6 text-lg leading-relaxed text-afwn-slate max-w-xl">
            Your wellness journey through Anxiety, PTSD, and Postpartum starts here — with 52 weeks of guided training, daily journaling, and a 24-hour AI assistant. Educational support, always within reach.
          </p>
        </Reveal>
        <Reveal i={3}>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Btn href={APP_URL} data-testid="hero-cta-button" variant="primary">Start your 7 Day to Calm Journey <ArrowRight size={18} /></Btn>
            <Btn href="#app" variant="ghost">See how it works</Btn>
          </div>
        </Reveal>
        <Reveal i={4}>
          <a href="#ebook" data-testid="hero-ebook-link" className="mt-5 inline-flex items-center gap-3 text-sm italic text-afwn-slate hover:text-afwn-green transition-colors group">
            <img src="/ebook/cover.jpg" alt="Anxiety Relief in 7 Minutes e-book cover" data-testid="hero-ebook-cover" className="h-14 w-auto rounded-[3px] shadow-md shadow-afwn-navy/20 ring-1 ring-afwn-navy/10 transition-transform duration-300 group-hover:-rotate-3 group-hover:scale-105" />
            <span className="inline-flex items-center gap-2 flex-wrap"><BookOpen size={16} className="text-afwn-amber" /> Includes free e-book + audiobook: <span className="font-medium text-afwn-navy not-italic group-hover:text-afwn-green">“Anxiety Relief in 7 Minutes”</span> <ArrowRight size={14} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" /></span>
          </a>
        </Reveal>
      </div>
      <div className="lg:col-span-5 relative">
        <Reveal i={2}>
          <div className="grid grid-cols-2 gap-3 sm:gap-4 h-[480px] sm:h-[540px]">
            <div className="row-span-2 rounded-[1.75rem] overflow-hidden shadow-xl shadow-afwn-navy/10">
              <img src={ASSETS.heroSunrise} alt="Sunrise over the mountains" className="w-full h-full object-cover" />
            </div>
            <div className="rounded-[1.75rem] overflow-hidden shadow-xl shadow-afwn-navy/10">
              <img src={ASSETS.heroYoga} alt="Silhouette of a woman doing yoga at sunset" className="w-full h-full object-cover" />
            </div>
            <div className="rounded-[1.75rem] overflow-hidden shadow-xl shadow-afwn-navy/10">
              <img src={ASSETS.heroHiking} alt="A person hiking with their dog at dusk" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white/75 backdrop-blur-xl border border-white/60 shadow-[0_8px_32px_rgba(0,0,0,0.08)] rounded-2xl px-5 py-4 flex items-center gap-3">
            <div className="flex -space-x-1">
              {["#F0731A", "#0B6B5E", "#C42462"].map((c) => <span key={c} className="w-8 h-8 rounded-full border-2 border-white" style={{ background: c }} />)}
            </div>
            <div>
              <div className="flex text-afwn-amber">{[...Array(5)].map((_, i) => <Star key={`star-${i}`} size={13} fill="currentColor" />)}</div>
              <p className="text-xs text-afwn-slate mt-0.5">Trusted by our growing community</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
